module.exports = __webpack_public_path__ + "assets/images/ae199e6a275ad83a0962535148eb88a0.png";